import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import Chart from 'chart.js/auto';
import { Tick } from 'chart.js/dist/core/core.scale';
import 'chartjs-adapter-dayjs-4';
// import { Chart } from 'chart.js';

@Component({
  selector: 'app-bar-chart',
  standalone: true,
  imports: [],
  templateUrl: './bar-chart.component.html',
  styleUrl: './bar-chart.component.scss',
})
export class BarChartComponent implements OnInit {
  @Input() chartId!: string;
  @Input() type!: 'bar' | 'line';
  @ViewChild('canvas', { read: ElementRef, static: true }) canvas!: ElementRef<any>;
  public chart: any;

  // https://codesandbox.io/p/sandbox/react-chartjs-2-line-chart-with-bg-gradient-ymmio?file=%2Fsrc%2FApp.js%3A8%2C5-25%2C75
  // https://stackoverflow.com/questions/72828471/chart-js-gradient-background-problems-with-browser-zoom
  customCanvasBackgroundColor = {
    id: 'customCanvasBackgroundColor',
    beforeDraw: (chart: any, args: any, options: any) => {
      const {
        ctx,
        chartArea: { left, right, top, bottom, width, height },
      } = chart;
      const canvas = chart.canvas;
      const chartArea = chart.chartArea;

      ctx.save();
      // Chart background
      const gradientBack = canvas.getContext('2d').createLinearGradient(right, bottom, right, top);
      // this.drawChartBackground(gradientBack);
      this.drawChartBackgroundReverse(gradientBack);
      ctx.fillStyle = gradientBack;
      ctx.fillRect(
        chartArea.left,
        chartArea.bottom,
        chartArea.right - chartArea.left,
        chartArea.top - chartArea.bottom
      );
    },
  };

  ngOnInit(): void {
    const labeldata = [2024, 2023, 2022, 2021, 2020];

    // multiple datasets: https://stackoverflow.com/questions/38101859/chart-js-line-chart-with-different-labels-for-each-dataset
    // hier würden wir alle datumse aus allen linien sammeln und chronologisch in dem labeldata als string mitgeben, dann die datasets x+y angeben.
    // ergebnis ist: abstand zwicshen punkten entspricht nicht der Dauer Zeit die vergangen ist, sondern ist fix gleich bei allen datenpunkten

    // chronological: https://www.chartjs.org/docs/latest/axes/cartesian/time.html
    // https://stackoverflow.com/questions/78029893/how-to-put-dates-in-charjs-angular-17

    this.chart = new Chart(this.canvas.nativeElement, {
      type: 'bar', //this denotes tha type of chart
      data: {
        // labels: labeldata,
        datasets: [
          {
            label: 'left',
            data: [
              { x: new Date('2018-01-20T20:00:00'), y: [-1, 1] },
              { x: new Date('2018-01-28T20:00:00'), y: [-1, 1] },
              { x: new Date('2018-04-21T20:00:00'), y: [-1, 3] },
              { x: new Date('2018-06-21T20:00:00'), y: [-1, 0] },
              { x: new Date('2018-09-21T20:00:00'), y: [-1, 2] },
            ],
            // backgroundColor: 'rgb(0,0,255, 1)',
            // borderWidth: 1,
            // tension: 0.3,
            // minBarLength: 5,
            barThickness: 5,
            // barPercentage: 0.5,
            categoryPercentage: 0.5,
          },
          {
            label: 'right',
            data: [
              { x: new Date('2018-01-20T20:00:00'), y: [-1, 3] },
              { x: new Date('2018-01-28T20:00:00'), y: [-1, 2] },
              { x: new Date('2018-04-21T20:00:00'), y: [-1, 2] },
              { x: new Date('2018-06-21T20:00:00'), y: [-1, 1] },
              { x: new Date('2018-09-21T20:00:00'), y: [-1, 0] },
            ],
            // backgroundColor: 'rgb(0,255,0, 0.8)',
            // borderWidth: 1,
            // tension: 0.2,
            // minBarLength: 2,
            barThickness: 5,
            // barPercentage: 0.5,
            categoryPercentage: 0.5,
          },

          // {
          //   label: 'Arat',
          //   data: [
          //     { x: '1', y: 0 },
          //     { x: '2', y: 1 },
          //     { x: '3', y: 4 },
          //   ],
          //   borderWidth: 1,
          //   pointBorderWidth: 1,
          //   // backgroundColor: colordata,
          //   // barThickness: 40,
          //   // tension: 0.5,
          // },
        ],
      },
      options: {
        responsive: true,
        aspectRatio: this.type === 'bar' ? 2 : 4,
        animation: {
          delay: 300,
        },
        layout: {
          // autoPadding:true
          padding: {
            left: 80,
            right: 30,
          },
        },
        scales: {
          y: {
            reverse: true,
            position: 'right',
            afterBuildTicks: scale => {
              scale.ticks = [
                {
                  value: 0,
                },
                {
                  value: 1,
                },
                {
                  value: 2,
                },
                {
                  value: 3,
                },
                {
                  value: 4,
                },
              ];
            },
            min: -0.5,
            max: 4.5,
            ticks: {
              stepSize: 1,
              callback: (tickValue: string | number, index: number, ticks: Array<any>) => {
                if (tickValue === 5 || tickValue === -1) {
                  return;
                } else {
                  return tickValue;
                }
              },
            },
            // beginAtZero: false,
            grid: {
              display: false,
            },
          },
          x: {
            // offset: true,
            // display: false,
            // beginAtZero: true,
            grid: {
              display: false,
            },
            type: 'time',
            // time: {
            //   unit: 'day',
            // },
          },
        },
        plugins: {
          legend: {
            position: 'right',
          },
        },
      },
      plugins: [this.customCanvasBackgroundColor],
    });
  }

  drawChartBackground(gradientBack: any) {
    gradientBack.addColorStop(0, 'rgba(255,255,255,1)');
    gradientBack.addColorStop(0.2, 'rgba(255,255,255,1)');

    gradientBack.addColorStop(0.2, 'rgba(252,252,239,1)');
    gradientBack.addColorStop(0.4, 'rgba(252,252,239,1)');

    gradientBack.addColorStop(0.4, 'rgba(252,244,219,1)');
    gradientBack.addColorStop(0.6, 'rgba(252,244,219,1)');

    gradientBack.addColorStop(0.6, 'rgba(255,228,200,1)');
    gradientBack.addColorStop(0.8, 'rgba(255,228,200,1)');

    gradientBack.addColorStop(0.8, 'rgba(251,221,221,1)');
    gradientBack.addColorStop(1, 'rgba(251,221,221,1)');
  }

  drawChartBackgroundReverse(gradientBack: any) {
    gradientBack.addColorStop(0, 'rgba(251,221,221,1)');
    gradientBack.addColorStop(0.2, 'rgba(251,221,221,1)');

    gradientBack.addColorStop(0.2, 'rgba(255,228,200,1)');
    gradientBack.addColorStop(0.4, 'rgba(255,228,200,1)');

    gradientBack.addColorStop(0.4, 'rgba(252,244,219,1)');
    gradientBack.addColorStop(0.6, 'rgba(252,244,219,1)');

    gradientBack.addColorStop(0.6, 'rgba(252,252,239,1)');
    gradientBack.addColorStop(0.8, 'rgba(252,252,239,1)');

    gradientBack.addColorStop(0.8, 'rgba(255,255,255,1)');
    gradientBack.addColorStop(1, 'rgba(255,255,255,1)');
  }
}
